import { render, staticRenderFns } from "./ProjectFormItem.vue?vue&type=template&id=df64ebba&scoped=true&"
import script from "./ProjectFormItem.vue?vue&type=script&lang=js&"
export * from "./ProjectFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df64ebba",
  null
  
)

export default component.exports